import React, { useState, useEffect } from "react";
import "./App.css";
import GameBoard from "./GameBoard";
import { playGameOverSound, isMuted, toggleMuted } from "./sounds";

function App() {
  const [gameState, setGameState] = useState("MENU");
  const [highestScore, setHighestScore] = useState(0);
  const [currentScore, setCurrentScore] = useState(0);
  const [muted, setMutedState] = useState(isMuted());

  // Load high score from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem("blockBurstHighestScore");
    if (saved) setHighestScore(parseInt(saved, 10));
  }, []);

  const startGame = () => {
    setCurrentScore(0);
    setGameState("PLAYING");
  };

  const handleGameOver = (finalScore) => {
    playGameOverSound();
    if (finalScore > highestScore) {
      setHighestScore(finalScore);
      localStorage.setItem("blockBurstHighestScore", finalScore.toString());
    }
    setCurrentScore(finalScore);
    setGameState("GAMEOVER");
  };

  const handleToggleMute = () => {
    const nowMuted = toggleMuted();
    setMutedState(nowMuted);
  };

  return (
    <div className="App">
      {/* Sound toggle — only on main menu */}
      {gameState === "MENU" && (
        <button
          className="btn-mute"
          onClick={handleToggleMute}
          aria-label={muted ? "Unmute" : "Mute"}
        >
          {muted ? "🔇" : "🔊"}
        </button>
      )}

      {gameState === "MENU" && (
        <div className="menu-container">
          <h1>Block Burst</h1>
          <div className="highest-score">Highest Score: {highestScore}</div>
          <button className="btn-primary" onClick={startGame}>Play Game</button>
        </div>
      )}

      {gameState === "PLAYING" && (
        <>
          <h1>Block Burst</h1>
          <GameBoard
            onGameOver={handleGameOver}
            score={currentScore}
            setScore={setCurrentScore}
          />
        </>
      )}

      {gameState === "GAMEOVER" && (
        <div className="menu-container">
          <h1 className="game-over-title">GAME OVER</h1>
          <div className="final-score">Score: <span>{currentScore}</span></div>
          {currentScore >= highestScore && currentScore > 0 && (
            <p className="new-high-score">NEW HIGH SCORE!</p>
          )}
          <button className="btn-primary" onClick={startGame}>Play Again</button>
          <button className="btn-secondary" onClick={() => setGameState("MENU")}>Main Menu</button>
        </div>
      )}
    </div>
  );
}

export default App;
